import { HiOutlineChatAlt2, HiOutlineCog, HiOutlineShieldCheck } from 'react-icons/hi';

// Mirrors the `scope` claim of the access-key JWT (botcircuits-backend app-access-key-service).
export const ACCESS_KEY_SCOPES = {
    RUNTIME: 'runtime',
    MANAGEMENT: 'management',
};

export const ACCESS_KEY_SCOPE_OPTIONS = [
    {
        value: ACCESS_KEY_SCOPES.RUNTIME,
        label: 'Runtime',
        description: 'Chat with your agent through the runtime (pubsub) API. Cannot manage resources.',
        icon: HiOutlineChatAlt2,
    },
    {
        value: ACCESS_KEY_SCOPES.MANAGEMENT,
        label: 'Management',
        description: 'Manage applications, tools and configuration through the REST API. Cannot chat.',
        icon: HiOutlineCog,
    },
];

const BADGE_BASE = 'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset';

const SCOPE_BADGES = {
    [ACCESS_KEY_SCOPES.RUNTIME]: {
        label: 'Runtime',
        icon: HiOutlineChatAlt2,
        className: 'bg-lime-50 text-lime-800 ring-lime-600/20 dark:bg-brand-lime/10 dark:text-brand-lime dark:ring-brand-lime/30',
    },
    [ACCESS_KEY_SCOPES.MANAGEMENT]: {
        label: 'Management',
        icon: HiOutlineCog,
        className: 'bg-gray-900 text-white ring-gray-900',
    },
};

// Keys created before scopes existed have no scope and keep access to every API.
const LEGACY_BADGE = {
    label: 'Full access',
    icon: HiOutlineShieldCheck,
    className: 'bg-gray-50 text-gray-600 ring-gray-500/20',
};

export function ScopeBadge({ scope }) {
    const { label, icon: Icon, className } = SCOPE_BADGES[scope] || LEGACY_BADGE;
    return (
        <span className={`${BADGE_BASE} ${className}`} title={scope ? undefined : 'Legacy key: valid for both runtime and management APIs'}>
            <Icon className="h-3.5 w-3.5" aria-hidden="true" />
            {label}
        </span>
    );
}

export function EnvironmentBadge({ environment }) {
    const live = environment === 'live';
    return (
        <span className={`${BADGE_BASE} ${live
            ? 'bg-emerald-50 text-emerald-700 ring-emerald-600/20 dark:bg-emerald-950 dark:text-emerald-300 dark:ring-emerald-500/30'
            : 'bg-amber-50 text-amber-700 ring-amber-600/20 dark:bg-amber-950 dark:text-amber-300 dark:ring-amber-500/30'}`}>
            <span className={`h-1.5 w-1.5 rounded-full ${live ? 'bg-emerald-500' : 'bg-amber-500'}`} aria-hidden="true" />
            {live ? 'Live' : 'Test'}
        </span>
    );
}
